import React, { useState, useEffect, FC, useCallback } from 'react';
import KickImage from 'Reuseables/KickImage';
import { doClearResetPassword, doResetPassword } from "../../../actions/resetPasswordAction"
import { connect } from "react-redux"
import ResetPassword from "../../../images/reset-password.png"
import { withRouter } from "react-router-dom"
import HideEyesInput from "../../../images/hide-eyes-input.png"
import ShowEyesInput from "../../../images/show-eyes-input.png"
import { Alert } from "reactstrap"
import { isEmail, isValidPasswordNew } from "../../../helpers/regex"
import _ from 'lodash';

type PageResetPassword = {
  load: () => any;
  submit: (payload: Object) => any;
  dataReset: Object;
  match: Params;
}

interface Params {
  params: Token;
}

interface Token {
  token: string;
}

const PageResetPasswordV3: FC<PageResetPassword> = ({ load, submit, dataReset, match, history, location }) => {

  const [newPassword, setNewPassword] = useState("")
  const [email, setEmail] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [buttonColor, setButtonColor] = useState(false)
  const [token, setToken] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [emailError, setEmailError] = useState("")
  const [passwordError, setPasswordError] = useState("")
  const [confirmPasswordError, setConfirmPasswordError] = useState("")
  const [submitError, setSubmitError] = useState("")

  useEffect(() => {
    if (newPassword && confirmPassword && email) {
      setButtonColor(true)
    } else {
      setButtonColor(false)
    }
  }, [newPassword, confirmPassword, email])

  useEffect(() => {
    let { token } = match.params
    const searchQuery = location.search

    if (typeof searchQuery && searchQuery?.length > 0) {
      const email = searchQuery?.split("=")?.[1] ?? ""
      setEmail(email)
    }
    setToken(token)
    load()
  }, [])

  useEffect(() => {
    if (dataReset && dataReset.error && dataReset.error.message) {
      setSubmitError(dataReset.error.message)
    }
  }, [dataReset])

  interface Value {
    value: string;
  }

  interface Target {
    target: Value;
  }

  function handleInputNewPassword(e: Target) {
    setNewPassword(e.target.value)
    debounceFn(e.target.value, "new_password", "")
  }

  function handleInputConfirmPassword(e: Target) {
    setConfirmPassword(e.target.value)
    debounceFn(e.target.value, "old_password", newPassword)
  }

  async function submitResetPassword(e: Event) {
    try {
      e.preventDefault()

      await setEmailError("")
      await setPasswordError("")
      await setConfirmPasswordError("")
      await setSubmitError("")

      const isValidForm = await validateForm(email, newPassword, confirmPassword)

      if (isValidForm) {
        let payload = {
          email,
          password: newPassword,
          password_confirmation: confirmPassword,
          x_token: token
        }

        let data = await submit(payload)

        if (data) {
          history.push("/reset-password/auth/success")
        }
      }
    } catch (e) {
      null
    }
  }

  const handleChangeNewPassword = (password, type, newPassword) => {
    if(type === "new_password"){
      if (!isValidPasswordNew(password)) {
        //USING PASSWORD VALIDATION AND ALLOW WHITESPACE
        setPasswordError("Your password at least contain 8 characters include (. ! -) and combine with capital letter or numeric.")
      } else {
        setPasswordError("")
      }
    } else {
      if (password !== newPassword) {
        setConfirmPasswordError("Confirm password not same with your password.")
      } else {
        setConfirmPasswordError("")
      }
    }
  }

  const debounceFn = useCallback(_.debounce(handleChangeNewPassword, 1000), []);

  function handleNewPassword() {
    setShowPassword(!showPassword)
  }

  function handleConfirmPassword() {
    setShowConfirmPassword(!showConfirmPassword)
  }

  function handleInputEmail(e: Target) {
    const emailText = (e.target.value).replace(/\s/g, ''); //HANDLE TRIM WHITE SPACE

    setEmail(emailText);
  }

  function validateForm(email: String, password: String, confirmPassword: String) {
    if (email == "") {
      setEmailError("Input your email.")
      return false;
    } else if (!isEmail(email)) {
      setEmailError("Incorrect email")
      return false;
    }

    if (password === "") {
      setPasswordError("Input your password")
      return false;
    } else if (!isValidPasswordNew(password)) {
      //USING PASSWORD VALIDATION AND ALLOW WHITESPACE
      setPasswordError("Your password at least contain 8 characters include (. ! -) and combine with capital letter or numeric.")

      setConfirmPasswordError("Your password at least contain 8 characters include (. ! -) and combine with capital letter or numeric.")
      return false;
    }

    if (confirmPassword === "") {
      setConfirmPasswordError("Input your confirm password.")
      return false;
    } else if (confirmPassword !== password) {
      setConfirmPasswordError("Confirm password not same with your password.")
      return false;
    }

    return true;
  }

  return (
    <div className="reset-password__Container">
      <div className="reset-password__Section">
        <KickImage className="image__Reset-Password" src={ResetPassword} alt="image reset password" />
        <h4>Reset Password</h4>
        {
          submitError && <Alert color="danger">{submitError}</Alert>
        }
        <form className='form-group__Reset-Password' onSubmit={submitResetPassword}>
          <input value={email} placeholder="Email" className="form-input__Email" onChange={handleInputEmail} type="text" />
          {
            emailError && <p className="email-error">{emailError}</p>
          }
          <div className="new-password-container">
            <input onBlur={() => handleChangeNewPassword(newPassword, "new_password", "")} value={newPassword} placeholder="New Password" className="form-input__New-Password" onChange={handleInputNewPassword} type={showPassword ? "text" : "password"} />
            <KickImage onClick={() => handleNewPassword()} src={showPassword ? ShowEyesInput : HideEyesInput} alt="visibile-password" className="new-password-img" />
          </div>
          {
            passwordError && <p className="password-error">{passwordError}</p>
          }
          <div className="confirm-password-container">
            <input onBlur={() => handleChangeNewPassword(confirmPassword, "old_password", newPassword)}  value={confirmPassword} placeholder="Confirm Password" className="form-input__Confirm-Password" onChange={handleInputConfirmPassword} type={showConfirmPassword ? "text" : "password"} />
            <KickImage onClick={() => handleConfirmPassword()} src={showConfirmPassword ? ShowEyesInput : HideEyesInput} alt="visible-password" className="confirm-password-img" />
          </div>
          {
            confirmPasswordError && <p className="confirm-error">{confirmPasswordError}</p>
          }
          <input style={{ backgroundColor: buttonColor ? "#159953" : "#e0e0e0" }} className="form-submit__Reset-Password" type="submit" />
        </form>
      </div>
    </div>
  )
}

interface State {
  dataResetPassword: Object
}

const mapStateToProps = (state: State) => ({
  dataReset: state.dataResetPassword
})

const mapDispatchToProps = (dispatch: Function) => ({
  load: () => dispatch(doClearResetPassword()),
  submit: (payload: Object) => dispatch(doResetPassword(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PageResetPasswordV3))